import { render } from "./mathjaxContent.vue?vue&type=template&id=30cd98f2"
import script from "./mathjaxContent.vue?vue&type=script&lang=js"
export * from "./mathjaxContent.vue?vue&type=script&lang=js"

import "./mathjaxContent.vue?vue&type=style&index=0&id=30cd98f2&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__